import {
  IMAGE_JPEG_QUALITY,
  IMAGE_MAX_EDGE_PX,
  MAX_IMAGE_BYTES,
} from '../constants/notice-images';

/**
 * Decode an image File, resize so the long edge ≤ IMAGE_MAX_EDGE_PX, encode as JPEG.
 * Rejects if the result exceeds MAX_IMAGE_BYTES.
 */
export async function compressImageForUpload(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.min(
      1,
      IMAGE_MAX_EDGE_PX / Math.max(bitmap.width, bitmap.height),
    );
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Could not prepare image for upload.');
    }
    ctx.drawImage(bitmap, 0, 0, width, height);

    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob(
        (result) => {
          if (result) resolve(result);
          else reject(new Error('Could not encode image as JPEG.'));
        },
        'image/jpeg',
        IMAGE_JPEG_QUALITY,
      );
    });

    if (blob.size > MAX_IMAGE_BYTES) {
      throw new Error(
        `Image is too large after compression (max ${MAX_IMAGE_BYTES / (1024 * 1024)} MB).`,
      );
    }
    return blob;
  } finally {
    bitmap.close();
  }
}
